<script lang="ts" setup>
import type { StatusColor } from '~/types'

defineProps<{
  color: StatusColor
  title: string
}>()
</script>

<template>
  <span class="status whitespace-nowrap" :class="color">
    {{ title }}
  </span>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.status {
  background: color.mix(variables.$main-gray-color, white, 10%);
  border-radius: 4px;
  display: inline-block;
  font-size: 14px;
  line-height: 14px;
  padding: 4px;

  @each $color-class, $color in (
    'blue': variables.$main-blue-color,
    'gray': variables.$main-gray-color,
    'green': variables.$main-green-color,
    'orange': variables.$main-orange-color,
    'purple': variables.$main-purple-color,
    'red': variables.$main-red-color,
    'yellow': variables.$main-yellow-color
  ) {
    &.#{$color-class} {
      background: color.mix($color, white, 10%);
      color: $color;
    }
  }
}
</style>
